module.exports = __webpack_public_path__ + "static/media/home-process-6.7e6162d7.svg";